<template>
  <rmr-modal
    :value="value"
    variant="gradient"
    :icon="icons.mdiVideoOutline"
    eyebrow="Guide d'utilisation"
    title="Créer un article via transcription vidéo"
    max-width="720"
    @input="$emit('input', $event)"
    @close="$emit('input', false)"
  >
    <template #body>
      <div class="pbv-help">
        <ol class="pbv-help__steps">
          <li>
            <strong>Choisissez le site</strong>, collez l'URL de la vidéo
            (YouTube, Instagram, TikTok, X) et lancez l'analyse. La
            transcription est mise en cache : relancer la même URL est
            instantané.
          </li>
          <li>
            <strong>Brique de transcription</strong> — « Par défaut » applique
            la brique réglée par l'admin pour la plateforme ; si elle échoue, la
            brique de fallback prend le relais et un avertissement s'affiche.
            Choisir une brique à la main est <em>strict</em> : si elle échoue,
            la page le dit au lieu de basculer sur une autre. Une brique « sans
            time codes » ne permet pas la découpe en angles. Un site non reconnu
            est traité comme « Autre » (voie audio).
          </li>
          <li>
            <strong>Ignorer le cache</strong> retranscrit la vidéo — utile pour
            comparer deux briques sur la même vidéo.
          </li>
          <li>
            <strong>Relisez et corrigez la transcription</strong> si besoin (nom
            propre, phrase parasite), puis enregistrez : c'est ce texte que la
            génération utilisera. Les time codes suivent la correction.
          </li>
          <li>
            <strong>Proposez des angles.</strong> Avec la découpe, chaque angle
            porte les bornes du passage qui l'alimente ; l'article n'utilise que
            ce passage et embarque la vidéo au bon time code. « Proposer
            d'autres angles » en ajoute sans toucher aux existants.
          </li>
          <li>
            <strong>Cochez, ajustez, générez.</strong> Le template de prompt, le
            statut de publication et « forcer l'angle comme titre » sont dans le
            menu Options de la barre du bas. Un article est mis en file par
            angle coché.
          </li>
        </ol>
        <p class="pbv-help__note">
          La description publiée avec la vidéo est transmise au rédacteur IA en
          plus de la transcription : elle précise souvent les noms propres et le
          sujet exact.
        </p>
      </div>
    </template>
  </rmr-modal>
</template>

<script>
import { mdiVideoOutline } from "@mdi/js";

import RmrModal from "@/components/ui/layout/RmrModal.vue";

export default {
  name: "VideoHelpModal",
  components: { RmrModal },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { icons: { mdiVideoOutline } };
  },
};
</script>

<style lang="scss" scoped>
.pbv-help {
  padding: 4px 4px 0;
  font-size: 14px;
  line-height: 1.55;
  color: $rmr-text-secondary;
}

.pbv-help__steps {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  strong {
    color: $rmr-text-primary;
  }
}

.pbv-help__note {
  margin: 16px 0 0;
  padding: 10px 12px;
  border-radius: $rmr-radius-md;
  background: $rmr-surface-1;
  font-size: 13px;
}
</style>
